<template>
  <!-- Toggle button for small screens -->
  <div class="md:hidden p-4">
    <button
      @click="showSidebar = !showSidebar"
      class="w-full px-4 py-2 bg-blue-600 text-white rounded-xl"
    >
      {{ showSidebar ? 'Hide Filters' : 'Show Filters' }}
    </button>
  </div>

  <!-- Sidebar -->
  <aside
    v-if="showSidebar || isDesktop"
    class="bg-gray-900 border border-gray-800 rounded-2xl p-5 w-full md:w-64 text-white space-y-6 sticky top-20 h-fit"
  >
    <!-- Categories -->
    <div id="filterCategories">
      <h3 class="text-lg font-semibold mb-3">Categories</h3>
      <div class="space-y-2">
        <label v-for="item in categories" :key="item.key" class="flex items-center gap-2 text-sm">
          <input
            type="checkbox"
            :value="item.key"
            v-model="selected.categories"
            class="accent-blue-500"
          />
          {{ item.name }}
        </label>
      </div>
    </div>

    <!-- Tags -->
    <!-- <div>
      <h3 class="text-lg font-semibold mb-3">Tags</h3>
      <div
        class="space-y-2 max-h-32 overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-transparent hover:scrollbar-thumb-gray-600"
      >
        <label v-for="tag in tags" :key="tag" class="flex items-center gap-2 text-sm">
          <input
            type="checkbox"
            :value="tag"
            v-model="selected.tags"
            class="accent-blue-500"
          />
          {{ tag }}
        </label>
      </div>
    </div> -->

    <primary-button @click="applyFilters" class="w-full mt-4">
      Apply Filters
    </primary-button>
  </aside>
</template>

<script setup>
  import { reactive, defineEmits, ref, onMounted } from 'vue'
  import { getAllCategories } from '@/utils/category'
  import { useRoute, useRouter } from 'vue-router'
  import PrimaryButton from '../button/PrimaryButton.vue'

  const route = useRoute()
  const router = useRouter()
  const categories = ref([])
  // const tags = ['Leadership', 'Remote', 'Online', 'Scholarship', 'STEM']

  const selected = reactive({
    categories: [],
    tags: [],
  })

  const emit = defineEmits(['filter'])
  const showSidebar = ref(false)
  const isDesktop = ref(false)

  const applyFilters = () => {
    emit('filter', { ...selected })
    router.push({
      name: 'OpportunityIndex',
      query: {
        categories: selected.categories
      }
    })
  }

  // Detect screen size
  onMounted(async () => {
    const checkSize = () => {
      isDesktop.value = window.innerWidth >= 768
      if (isDesktop.value) showSidebar.value = true
    }

    checkSize()

    categories.value = await getAllCategories()
    
    if (typeof route.query.categories != 'undefined')
    {
      if (typeof route.query.categories === 'string') {
        selected.categories.push(route.query.categories)
      } else if (Array.isArray(route.query.categories.flat())) {
        selected.categories = [...route.query.categories];
      }
    }
    window.addEventListener('resize', checkSize)
  })
</script>
